import api from "@/api";

type ContentType = "video" | "making-of" | "live";

export interface LatestVideoData {
  name: string;
  videoPath: string;
  livePath: string;
  // TODO(panda-migration): remove `urlPanda` after Fase 3 is in production
  // and the backend stops emitting it. Kept here to minimize diff / keep
  // revert of Fase 2 cheap.
  urlPanda: string;
  processing: boolean;
  thumbVideo: string;
  modelName: string;
  cover: string;
}

const endpointMap: Record<ContentType, string> = {
  video: "v1/modelos/getLatestVideo",
  "making-of": "v1/modelos/getLatestMakingOf",
  live: "v1/modelos/getLatestLive",
};

export function useLatestVideo(contentType: ContentType) {
  const latestVideo = ref<LatestVideoData | null>(null);
  const loading = ref(false);

  async function fetchLatestVideo() {
    loading.value = true;
    try {
      const { data } = await api.get(endpointMap[contentType]);
      if (data.video) {
        latestVideo.value = {
          ...data.video,
          modelName: data.modelName ?? "",
          cover: data.cover ?? "",
        };
      } else {
        latestVideo.value = null;
      }
    } catch (error) {
      console.error("Error fetching latest video:", error);
      latestVideo.value = null;
    } finally {
      loading.value = false;
    }
  }

  onMounted(() => {
    fetchLatestVideo();
  });

  return {
    latestVideo,
    loading,
  };
}
